<mat-checkbox ([ngModel])="value" (click)="next()" [disabled]="disabled" 
    [indeterminate]="value === false"
    [color]="value === false ? 'warn' : 'lighter'">
    <ng-content></ng-content>
</mat-checkbox>